import { render, staticRenderFns } from "./SimulatorSheet-Results.vue?vue&type=template&id=36d10148&scoped=true&"
import script from "./SimulatorSheet-Results.vue?vue&type=script&lang=js&"
export * from "./SimulatorSheet-Results.vue?vue&type=script&lang=js&"
import style0 from "./SimulatorSheet-Results.vue?vue&type=style&index=0&id=36d10148&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36d10148",
  null
  
)

export default component.exports